"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CameraIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var CameraIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("g", null,
        React.createElement("path", { d: "M13.3157 12.579C13.3157 13.3059 12.7268 13.8948 11.9999 13.8948C11.2729 13.8948 10.6841 13.3059 10.6841 12.579C10.6841 11.852 11.2729 11.2632 11.9999 11.2632C12.7268 11.2632 13.3157 11.852 13.3157 12.579Z", fill: "currentColor" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.0701 7.75411H18.5792C19.325 7.75411 19.8949 8.32482 19.8949 9.06989V16.0872C19.8949 16.7886 19.325 17.4029 18.5792 17.4029H5.42126C4.67536 17.4029 4.10547 16.7886 4.10547 16.0872V9.06989C4.10547 8.324 4.67536 7.75411 5.42126 7.75411H8.92947L9.80694 6H14.1926L15.0701 7.75411ZM8.93031 12.5789C8.93031 14.2895 10.2897 15.6488 12.0002 15.6488C13.7107 15.6488 15.0701 14.2895 15.0701 12.5789C15.0701 10.8684 13.7107 9.50905 12.0002 9.50905C10.2897 9.50905 8.93031 10.8684 8.93031 12.5789Z", fill: "currentColor" })))); };
exports.CameraIcon = CameraIcon;
